import LoLBackground from './LoLBackground';

export default LoLBackground;
